// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"hZ-z","subtitle":"iZ-z","wrapper":"jZ-z","leftArrow":"kZ-z","rightArrow":"lZ-z"};